<template>
  <div class="page-wrapper" id="demonstration-preview-colors">
      <h1>Preview oklch</h1>
      <div class="p-16 has-border" :style="`background-color: ${backgroundColor};`">
        <div>oklch</div>
        <div v-for="(color, colorIndex) in colorList" :key="color" class="m-b-16">
          <el-input v-model="colorList[colorIndex]" type="text" style="max-width: 100px;"/>
          <div>{{ semanticConfig[colorIndex] }}</div>
          <div class="m-r-8  line-wrap  flex justify-content-end">
            <div v-for="(light, index) in steplight" :key="`new2_${color}-${light}`" :class="`color-block ${index < 5 ? 'text-black' : 'text-white'} ${index == 5 ? 'shade-500' : ''}`" :style="`background-color: ${getColor(color, index, 'hex', true)};`">
              <div>
                <div class="m-b-4">{{ light }}</div>
                <div class="m-b-4">{{ getColor(color, index, 'hex', true) }}</div>
                <div class="m-b-4">{{ getColor(color, index, 'oklch', true) }}</div>
              </div>
            </div>
          </div>
          <hr>
        </div>
      </div>
      <div class="m-t-20">
        lib ที่ใช้ chroma-js
        <a @click="navigateTo('https://gka.github.io/chroma.js/')">(https://gka.github.io/chroma.js/)</a>
        คำสั่งที่ใช้ chroma(color).oklch()
        note จากพี่เต๋า ใช้ oklch color space วิธีคือ
      </div>
      <div class="m-t-10">
        1. เอา #hex ตั้งต้นมาแปลงเป็น oklch (l,c,h)
        <pre><code>let [lightness, chromacity, hue] = chroma(color).oklch()</code></pre>
      </div>
      <div class="m-t-10">
        2. เมื่อได้ค่า L, C, H ตั้งต้น จะไล่สเตปความสว่างที่ค่า L กับ C โดย
          <li>
            2.1 ค่า L จะแบ่งเป็น 2 ช่วง คือเสตปที่ 50-400 กับ 600-975 ซึ่งใช้วิธีคำนวนต่างกัน
              ช่วง 50-400 จะคำนวนด้วยสูตร: ((1 - ค่าคงที่ของแต่ละเสตป) * (1 - ค่า L ตั้งต้น)) + ค่า L ตั้งต้น
              ช่วง 600-975 จะคำนวนด้วยสูตร: ค่าคงที่ของแต่ละเสตป * ค่า L ตั้งต้น
          </li>
          <li>
            2.2 ค่า C ทุกสเตปจะคำนวนด้วยสูตร: ค่าคงที่ของแต่ละเสตป * ค่า C ตั้งต้น
          </li>
          <li>
            2.3 ค่า L และ C ที่สเตป 500 จะใช้ค่าตั้งต้น ไม่เปลี่ยนแปลง
          </li>
          <li>
            2.4 ค่า H ทุกสเตปจะใช้ค่าตั้งต้น ไม่เปลี่ยนแปลง
          </li>

        <pre class="m-t-10">
          const l_mod = this.step[index]?.l_mod
          const l_base = lightness
          lightness = index == this.mainStep ? lightness : index > this.mainStep ? l_base * l_mod : lightness = ((1 - l_mod) * (this.l_max - l_base)) + l_base

          chromacity = chromacity * this.step[index]?.c_mod
        </code></pre>
      </div>
      <div>
        3. เอา l,c,h แปลงกลับไปใช้อีกที
        <pre><code>let hex = chroma.oklch(lightness, chromacity, hue)</code></pre>
      </div>
      <pre class="m-t-20">
        ค่าอื่นๆ
        data = {
          steplight: [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 925, 950, 975],
          colorList: [
            '#9296a0', "#00b33c", "#FF2E38", "#db9a00", "#f55200", "#3d87ff", "#b452ff", "#ff2970", "#00b8cc",
            '#009989', //scgc
            '#009FDA', //ptt
            '#594F74' //purple
          ],
          mainStep: 5,
          l_base:0.65,
          c_base:0.24,
          l_max:1,
          c_max:0.4,
          step: [{"name":"50","l_mod":0.07,"c_mod":0.1},{"name":"100","l_mod":0.17,"c_mod":0.282},{"name":"200","l_mod":0.312,"c_mod":0.543},{"name":"300","l_mod":0.498,"c_mod":0.795},{"name":"400","l_mod":0.728,"c_mod":0.952},{"name":"500","l_mod":1,"c_mod":1},{"name":"600","l_mod":0.875,"c_mod":0.976},{"name":"700","l_mod":0.758,"c_mod":0.899},{"name":"800","l_mod":0.65,"c_mod":0.764},{"name":"900","l_mod":0.55,"c_mod":0.582},{"name":"925","l_mod":0.458,"c_mod":0.388},{"name":"950","l_mod":0.375,"c_mod":0.22},{"name":"975","l_mod":0.3,"c_mod":0.1}]
        }
      </code></pre>
  </div>
</template>

<script>
import chroma from 'chroma-js'
export default {
  data () {
    return {
      form: {},
      backgroundColor: '#fff',
      steplight: [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 925, 950, 975],
      colorList: [],
      mainStep: 5,
      l_base: 0.65,
      c_base: 0.24,
      l_max: 1,
      c_max: 0.4,
      step: [
        { name: '50', l_mod: 0.07, c_mod: 0.1 },
        { name: '100', l_mod: 0.17, c_mod: 0.291 },
        { name: '200', l_mod: 0.312, c_mod: 0.526 },
        { name: '300', l_mod: 0.498, c_mod: 0.756 },
        { name: '400', l_mod: 0.728, c_mod: 0.931 },
        { name: '500', l_mod: 1, c_mod: 1 },
        { name: '600', l_mod: 0.875, c_mod: 0.963 },
        { name: '700', l_mod: 0.758, c_mod: 0.866 },
        { name: '800', l_mod: 0.65, c_mod: 0.726 },
        { name: '900', l_mod: 0.55, c_mod: 0.561 },
        { name: '925', l_mod: 0.458, c_mod: 0.39 },
        { name: '950', l_mod: 0.375, c_mod: 0.23 },
        { name: '975', l_mod: 0.3, c_mod: 0.1 }
      ],
      semanticConfig: ['primary', 'secondary', 'tertiary', 'semanticRed', 'semanticYellow', 'semanticOrange', 'semanticBlue', 'semanticBluegreen', 'semanticGreen', 'semanticViolet', 'semanticPink']
    }
  },
  mounted () {
    setTimeout(this.getPrimaryColor, 500)
  },
  methods: {
    getColor (color, index, type) {
      if (chroma.valid(color)) {
        let [lightness, chromacity, hue] = this.getOklch(color, index)
        return type === 'hex' ? chroma.oklch(lightness, chromacity, hue) : `l ${lightness.toFixed(3)}, c ${chromacity.toFixed(3)}, h ${hue.toFixed(3)}`
      }
    },
    // testChroma () {
    //   const test = chroma('pink').darken().saturate(2).hex()
    //   console.log('test', test, chroma('pink'),  chroma('pink').hex())
    // },
    getOklch (color, index) {
      // chroma.oklch(Lightness, chromacity, hue)
      let [lightness, chromacity, hue] = chroma(color).oklch()

      // l = l_base*l_mod[step]
      // c = c_base*c_mod[step] หรือ c_input*c_mod[step]
      // h = h_input

      const l_mod = this.step[index]?.l_mod
      const l_base = lightness
      lightness = index == this.mainStep ? lightness : index > this.mainStep ? l_base * l_mod : lightness = ((1 - l_mod) * (this.l_max - l_base)) + l_base

      chromacity = chromacity * this.step[index]?.c_mod
      // chromacity = (chromacity ? chromacity : this.c_base) * this.step[index].c_mod

      return [lightness, chromacity, hue]
    },
    getPrimaryColor () {
      this.colorList = this.semanticConfig.map(config => this.$store.state.color[`${config}`])
      this.semanticConfig.push('coolGrey')
      this.colorList.push('#9296A0')
    },
    navigateTo (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">
#demonstration-preview-colors {
  .heading {
    margin-top: 0;
  }
  .color-block {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 100px;
    margin: 4px 0;
    color: white;
    font-size: 10px;
    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
    padding: 4px;
    font-size: 10px;

    &.small {
      width: 20px;
      height: 20px;
      margin: 4px;
    }
  }

  input {
    width: 120px;
  }

  .line-wrap {
    padding: 0 36px 0 0;
    width: 1450px;
    max-width: 100%;
  }
  .shade-500 {
    border: 3px solid rgb(255, 255, 255);
  }
}
</style>
